import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-574ecb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vehicle-selector" }
const _hoisted_2 = { class: "card card-body" }
const _hoisted_3 = {
  key: 1,
  class: "select-vehicle"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Choose a vehicle", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No vehicles found.", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_icon = _resolveComponent("icon")!
  const _component_AddOwnedVehicle = _resolveComponent("AddOwnedVehicle")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
            key: 0,
            class: "mt-5",
            centered: "",
            relative: ""
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isLoggedIn && !_ctx.creatingVehicle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "btn btn-block btn-outline-light btn-lg shadow-sm owned-vehicle",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exitVehicleCreation(_ctx.vehicleToCreate)))
                  }, [
                    _createElementVNode("img", {
                      class: "car-logo",
                      src: _ctx.getLogoPath(_ctx.vehicleToCreate)
                    }, null, 8, _hoisted_5),
                    _createTextVNode(" " + _toDisplayString(_ctx.vehicleToCreate.year) + " " + _toDisplayString(_ctx.vehicleToCreate.make) + " " + _toDisplayString(_ctx.vehicleToCreate.model), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-outline-light btn-lg btn-block shadow-sm add-vehicle",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startVehicleCreation && _ctx.startVehicleCreation(...args)))
                  }, [
                    _createVNode(_component_icon, { icon: ['far', 'plus'] }),
                    _createTextVNode(" Add a Vehicle ")
                  ])
                ]))
              : (_ctx.displayVehicleSelector && !_ctx.creatingVehicle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    (_ctx.ownedVehicles.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownedVehicles, (vehicle) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: `ov-${vehicle.id}`,
                              class: "btn btn-block btn-outline-light btn-lg shadow-sm owned-vehicle",
                              onClick: ($event: any) => (_ctx.exitVehicleCreation(vehicle))
                            }, [
                              _createElementVNode("img", {
                                class: "car-logo",
                                src: _ctx.getLogoPath(vehicle)
                              }, null, 8, _hoisted_10),
                              _createTextVNode(" " + _toDisplayString(vehicle.year) + " " + _toDisplayString(vehicle.make) + " " + _toDisplayString(vehicle.model), 1)
                            ], 8, _hoisted_9))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "btn btn-outline-light btn-lg btn-block shadow-sm add-vehicle",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startVehicleCreation && _ctx.startVehicleCreation(...args)))
                          }, [
                            _createVNode(_component_icon, { icon: ['far', 'plus'] }),
                            _createTextVNode(" Add a Vehicle ")
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  ]))
                : (_ctx.creatingVehicle)
                  ? (_openBlock(), _createBlock(_component_AddOwnedVehicle, {
                      key: 2,
                      zipcode: _ctx.zipcode,
                      onVehicleAdded: _ctx.exitVehicleCreation,
                      onVehicleCreationFailed: _ctx.vehicleCreationFailed
                    }, null, 8, ["zipcode", "onVehicleAdded", "onVehicleCreationFailed"]))
                  : _createCommentVNode("", true)
          ]))
    ])
  ]))
}